<template>
  <div v-show="list.length>0" style="">
    <el-row :class="classcomp(rowclass,item,i1,undefined)" :style="stylecomp(rowstyle,item,i1,undefined)" :key="i1" v-for="(item,i1) in list">
      <!--<template v-if="listtype=='auto'">-->
      <div v-if="listtype=='auto'" style="display:inline-block;padding-right:5px;" :key="i2" v-for="(obj,i2) in item">
        <slot :data="obj" :rowidx="i1" :colidx="i2"></slot>
      </div>
      <!--</template>-->
      <el-col v-if="listtype=='default'" :class="classcomp(itemclass,obj,i1,i2)" :style="stylecomp(itemstyle,obj,i1,i2)" :key="i2" :span="24/colnum" v-for="(obj,i2) in item">
        <slot :data="obj" :rowidx="i1" :colidx="i2"></slot>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import Vue from "vue";
  import $ from 'jquery';
  export default {
    name: 'MyListItem',
    props: {
//      listtype: {
//        type: [String],
//        default(){
//          return 'column';
//        }
//      },
      items: {
        type: [Array],
        default(){
          return [];
        }
      },
      rowstyle: {
        type: [String, Object, Function],
        default(){
          return {'padding-left': '5px'};
        }
      },
      rowclass: {
        type: [String, Object, Function],
      },
      itemstyle: {
        type: [String, Object, Function],
        default(){
          return {'padding-left': '5px'};
        }
      },
      itemclass: {
        type: [String, Object, Function],
      },
      colnum: [Number, String]
    },//此处col为对象,
    data(){
//      if (this.colnum == 'auto') {
//        this.listtype = 'auto';
//      }
      return {
        listtype: 'default',
        list: this.splitArrTo(this.items, this.colnum == 'auto' ? this.items.length : this.colnum)
      }
    },
    computed: {},
    watch: {
      items(){
        this.setAll(this.items);
      },
      colnum(){
        if (this.colnum == 'auto') {
          this.listtype = 'auto';
        }
        this.setAll(this.items);
      }
    },
    methods: {
      stylecomp: function (opt,data, rowIdx, colIdx) {
        if ($.isFunction(opt)) {
          return opt(data, rowIdx, colIdx)
        }
        if ($.isString(opt) && opt) {
          var arr = opt.split(';');
          var obj = {};
          for (var i = 0; i < arr.length; i++) {
            var sty = arr[i];
            if (sty) {
              var t = sty.split(':');
              obj[t[0]] = t[1];
            }
            return obj;
          }
        }
        return opt;
      },
      classcomp: function (opt,data, rowIdx, colIdx) {
        if ($.isFunction(opt)) {
          return opt(data, rowIdx, colIdx)
        }
        return opt;
      },
      getItem: function (rowidx, cellidx, data) {
        return this.list[rowidx][cellidx];
      },
      getAll: function (pluckfield) {
        return pluckfield ? $.pluck(this.items, pluckfield) : this.items;
      },
      setAll: function (arr) {
        this.items = arr;
        this.list = this.splitArrTo(this.items, this.colnum == 'auto' ? this.items.length : this.colnum);
      },
      splitArrTo(rawArr, colCount, clone) {
        var len = rawArr.length;
        var rowLen = Math.ceil(len / colCount);
        var arr = [];
        for (var i = 0; i < rowLen; i++) {
          var tr = [];
          for (var j = 0; j < colCount; j++) {
            if (i * colCount + j >= len) {
              break;
            }
            var td = {};
            if (clone == true) {
              $.extend(true, td, rawArr[i * colCount + j]);
            } else {
              td = rawArr[i * colCount + j];
            }
            tr.push(td);
          }
          arr.push(tr);
        }
        return arr;
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MyListItem.vue